/**
 * Custom display rules (business logic from PO)
 */

/**
 * Move item to specific position in array
 * @param {Array} items - array of items
 * @param {Function} predicate - function to find target item
 * @param {number} position - target position (0-indexed)
 * @returns {Array} - sorted array
 */
export function prioritizeItem(items, predicate, position = 1) {
  if (!items?.length) return items;

  const copy = [...items];
  const idx = copy.findIndex(predicate);

  if (idx > -1 && idx !== position && position < copy.length) {
    const [item] = copy.splice(idx, 1);
    copy.splice(position, 0, item);
  }

  return copy;
}

/**
 * Move category to specific position by treeid
 * @param {Array} categories - array of categories
 * @param {string} treeid - category treeid
 * @param {number} position - target position (0-indexed)
 * @returns {Array} - sorted categories
 */
export function prioritizeCategory(categories, treeid, position = 1) {
  return prioritizeItem(categories, (c) => c.treeid === treeid, position);
}
